import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { awardInstitutionOptions } from '@/module/Nomen/AwardInstitution/model/AwardInstitutionModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

import { useSortedNomen } from '@feature/utils';

type AwardInstitutionSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function AwardInstitutionSelectControl<T extends FieldValues>(props: AwardInstitutionSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(awardInstitutionOptions.getAll());
  const options = useSortedNomen(data, 'DESC');

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={options}
      {...props}
    />
  );
}
